import React from 'react';
import { Admin, Resource, CustomRoutes, ListGuesser, EditGuesser, ShowGuesser, Layout } from 'react-admin';
import { Route } from 'react-router-dom';
import { dataProvider } from './dataProvider/dataProvider';
import { authProvider } from './authProvider';
import { myTheme } from './theme';
import { MyAppBar } from './MyAppBar';
import MyDashboard from './Dashboard';
import { WalletList, WalletEdit, WalletCreate } from './resources/wallets';
import { UserCreate, UserList } from './resources/users';
import UserShow from './resources/UserShow';
import { SignalBotSettingCreate } from './resources/signalBotSettings';
import { BulkAddCrashPresets } from './resources/crashPresets/BulkAddCrashPresets';
import { CrashPresetList } from './resources/crashPresets/CrashPresetList';
import { AgentCreate, AgentEdit } from './resources/agents';
import { CategoryCreate } from './resources/categories';
import { GameCreate, GameEdit } from './resources/games';
import { BannerCreate, BannerEdit } from './resources/banners';
import { PromotionCreate, PromotionEdit } from './resources/promotions';
import { AppReleaseCreate } from './resources/appReleases';
import { RewardBonusCreate, RewardBonusEdit } from './resources/rewardBonuses';
import { DepositSettingsEdit, DepositSettingsCreate } from './resources/depositSettings';
import { WithdrawSettingsEdit, WithdrawSettingsCreate } from './resources/withdrawSettings';
import { WithdrawMethodCreate, WithdrawMethodEdit } from './resources/withdrawMethods';
import { UserWithdrawWalletCreate } from './resources/userWithdrawWallets';
import { ReferralEarningCreate } from './resources/referralEarnings';
import { PaymentMethodCreate, PaymentMethodEdit } from './resources/paymentMethods';
import { PaymentChannelCreate, PaymentChannelList, PaymentChannelEdit } from './resources/paymentChannels';
import { WithdrawRequestList, WithdrawRequestCreate, WithdrawRequestEdit } from './resources/withdrawals';
import { DepositRequestList, DepositRequestCreate, DepositRequestEdit } from './resources/deposits';
import { AgentSupportTicketShow, AgentSupportTicketList } from './resources/agentSupportTickets';

// ← নতুন যোগ হলো: support-tickets এর নিজস্ব List/Create/Edit/Show
import {
  SupportTicketList,
  SupportTicketCreate,
  SupportTicketEdit,
  SupportTicketShow,
} from './resources/supportTickets';

// ← নতুন যোগ হলো: chat-messages এর কাস্টম চ্যাট-স্টাইল পেজ
import { ChatMessagesList } from './resources/ChatMessagesList';

const MyLayout = (props) => <Layout {...props} appBar={MyAppBar} />;

function App() {
  return (
    <Admin
      dataProvider={dataProvider}
      authProvider={authProvider}
      theme={myTheme}
      layout={MyLayout}
      dashboard={MyDashboard}
      title="MyGame Admin Panel"
    >
      <CustomRoutes>
        <Route path="/crash-presets/bulk-add" element={<BulkAddCrashPresets />} />
      </CustomRoutes>

      <Resource name="wallets" list={WalletList} edit={WalletEdit} create={WalletCreate} />
      <Resource name="categories" list={ListGuesser} edit={EditGuesser} create={CategoryCreate} />
      <Resource name="games" list={ListGuesser} edit={GameEdit} create={GameCreate} />

      <Resource name="bets" edit={EditGuesser} show={ShowGuesser} />

      <Resource
        name="deposits"
        list={DepositRequestList}
        edit={DepositRequestEdit}
        create={DepositRequestCreate}
      />

      <Resource
        name="withdrawals"
        list={WithdrawRequestList}
        edit={WithdrawRequestEdit}
        create={WithdrawRequestCreate}
      />

      {/* ↓ list/edit/show/create সব ListGuesser/EditGuesser/ShowGuesser থেকে বদলে
          আসল কম্পোনেন্ট বসানো হলো — Pending/Solved স্ট্যাটাস ও ছবি প্রিভিউসহ */}
      <Resource
        name="support-tickets"
        list={SupportTicketList}
        create={SupportTicketCreate}
        edit={SupportTicketEdit}
        show={SupportTicketShow}
      />

      {/* ↓ ListGuesser/EditGuesser বাদ দিয়ে কাস্টম চ্যাট-স্টাইল পেজ বসানো হলো —
          এখানে conversation list, read/unread filter, ও admin reply — সবই আছে */}
      <Resource name="chat-messages" list={ChatMessagesList} />

      <Resource name="referral-earnings" list={ListGuesser} edit={EditGuesser} create={ReferralEarningCreate} />

      <Resource name="game-rounds" edit={EditGuesser} />

      <Resource name="crash-presets" list={CrashPresetList} edit={EditGuesser} />
      {/* ↓ EditGuesser বদলে BannerEdit বসানো হলো — Edit পেজেও image preview দেখাবে */}
      <Resource name="banners" list={ListGuesser} edit={BannerEdit} create={BannerCreate} />
      <Resource name="announcements" edit={EditGuesser} />
      {/* ↓ EditGuesser বদলে PromotionEdit বসানো হলো — Edit পেজেও image preview দেখাবে */}
      <Resource name="promotions" list={ListGuesser} edit={PromotionEdit} create={PromotionCreate} />
      <Resource name="app-releases" list={ListGuesser} edit={EditGuesser} create={AppReleaseCreate} />
      {/* ↓ EditGuesser বদলে PaymentMethodEdit বসানো হলো — Edit পেজেও logo preview দেখাবে */}
      <Resource name="payment-methods" list={ListGuesser} edit={PaymentMethodEdit} create={PaymentMethodCreate} />
      <Resource name="payment-channels" list={PaymentChannelList} edit={PaymentChannelEdit} create={PaymentChannelCreate} />
      <Resource name="deposit-settings" list={ListGuesser} edit={DepositSettingsEdit} create={DepositSettingsCreate} />
      {/* ↓ EditGuesser বদলে WithdrawMethodEdit বসানো হলো — Edit পেজেও logo preview দেখাবে */}
      <Resource name="withdraw-methods" list={ListGuesser} edit={WithdrawMethodEdit} create={WithdrawMethodCreate} />
      <Resource name="user-withdraw-wallets" list={ListGuesser} edit={EditGuesser} create={UserWithdrawWalletCreate} />
      <Resource name="withdraw-settings" list={ListGuesser} edit={WithdrawSettingsEdit} create={WithdrawSettingsCreate} />
      {/* ↓ EditGuesser বদলে RewardBonusEdit বসানো হলো — Edit পেজেও image preview দেখাবে */}
      <Resource name="reward-bonuses" list={ListGuesser} edit={RewardBonusEdit} create={RewardBonusCreate} />
      <Resource name="reward-bonus-claims" list={ListGuesser} edit={EditGuesser} />

      <Resource name="users" list={UserList} edit={EditGuesser} show={UserShow} create={UserCreate} />

      <Resource name="agents" list={ListGuesser} edit={AgentEdit} show={ShowGuesser} create={AgentCreate} />

      <Resource
        name="agent-support-tickets"
        list={AgentSupportTicketList}
        edit={EditGuesser}
        show={AgentSupportTicketShow}
      />

      <Resource name="agent-ticket-messages" edit={EditGuesser} />
      <Resource name="signal-bot-settings" list={ListGuesser} edit={EditGuesser} create={SignalBotSettingCreate} />
    </Admin>
  );
}

export default App;